<template>
    <!-- LEFT SIDE -->
    <div class="float-container left-side" :class="{ scrolled: isScrolled }">
        <transition-group name="pop" tag="div" class="icon-list">
            <div v-for="(item, index) in isDisplay ? leftIcons : []" :key="item?.name" class="icon-wrapper"
                :style="{ transitionDelay: `${index * 0.05}s` }" @click="goToPath(item?.name)">
                <img :src="item?.icon" alt="" />
            </div>
        </transition-group>
    </div>

    <!-- RIGHT SIDE -->
    <div class="float-container right-side" :class="{ scrolled: isScrolled }">
        <transition-group name="pop" tag="div" class="icon-list">
            <div v-for="(item, index) in isDisplay ? rightIcons : []" :key="item?.name" class="icon-wrapper"
                :style="{ transitionDelay: `${index * 0.05}s` }" @click="goToPath(item?.name)">
                <img :src="item?.icon" alt="" />
            </div>
        </transition-group>
    </div>
</template>


<script setup lang="ts">
import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, defineEmits, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const isScrolled = ref(false)
const router = useRouter()
const emits = defineEmits(["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA"])

const goToPath = (name: any) => {
    goToActivityPath(name, router, emits)
}

const leftIcons = computed(() => {
    const list = homeIconList.value || []
    return list.slice(0, Math.ceil(list.length / 2))
})
const rightIcons = computed(() => {
    const list = homeIconList.value || []
    return list.slice(Math.ceil(list.length / 2))
})

let scrollContainer: HTMLElement | Window = window
let scrollTimeout: number

const handleScroll = () => {
  const scrollTop =
    scrollContainer instanceof Window
      ? window.scrollY
      : scrollContainer.scrollTop

  isScrolled.value = scrollTop > 50

  clearTimeout(scrollTimeout)
  scrollTimeout = window.setTimeout(() => {
    isScrolled.value = false
  }, 500)
}

onMounted(() => {
  const app = document.querySelector('.scroll-container')
  scrollContainer = app || window
  scrollContainer.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  scrollContainer.removeEventListener('scroll', handleScroll)
})
</script>
<style scoped>
.float-container {
    position: fixed;
    bottom: 120px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    max-height: 70vh;
    gap: 8px;
    transition: transform 0.6s ease, opacity 0.6s ease;
    z-index: 900;
}

.icon-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.icon-wrapper img {
    border-radius: 10px;
    width: 80px;
    transition: transform 0.3s ease;
}

/* Right and left base positions */
.right-side {
    right: 10px;
}

.left-side {
    left: 10px;
}

/* When scrolled - push icons slightly off-screen */
.right-side.scrolled {
    transform: translateX(50px);
}

.left-side.scrolled {
    transform: translateX(-50px);
}

/* Hover to pull back */
.right-side.scrolled:hover,
.left-side.scrolled:hover {
    transform: translateX(0);
}

/* Slight hover zoom for icons */
.icon-wrapper img:hover {
    transform: scale(1.05);
}

/* ===== Transition-group pop effect ===== */
.pop-enter-from {
    transform: scale(0);
    opacity: 0;
}

.pop-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.pop-enter-to {
    transform: scale(1);
    opacity: 1;
}

.pop-leave-from {
    transform: scale(1);
    opacity: 1;
}

.pop-leave-active {
    transition: all 0.2s ease-in;
}

.pop-leave-to {
    transform: scale(0);
    opacity: 0;
}
</style>